import { Controller } from '@hotwired/stimulus';

import ajax from '@/modules/ajax';

export default class extends Controller {
  static outlets = ['modal'];

  static targets = ['commentField', 'submitButton'];

  open(event) {
    this.element.dataset.id = event.params.id;
    this.element.dataset.url = event.params.url;

    this.modalOutlet.open();
  }

  submit() {
    this.submitButtonTarget.disabled = true;

    ajax({
      always: () => { this.submitButtonTarget.disabled = false; },
      done: (json) => this.#onRefund(json),
      method: 'PATCH',
      params: { comment: this.commentFieldTarget.value },
      url: this.element.dataset.url,
    });
  }

  #onRefund(json) {
    this.modalOutlet.close();

    this.commentFieldTarget.value = '';

    this.dispatch('refund', { bubbles: true, detail: { id: this.element.dataset.id, json } });
  }
}
